import * as React from "react";
import { connect } from "react-redux";
import { I18n } from "react-redux-i18n";
import { ListGroup, ListGroupItem  } from "reactstrap";
import * as _ from "lodash";
import { scwApi } from "../../services/Api";
import { IndicatorDTO } from "../../services/models/IndicatorDTO";

import "./PanelSelectIndicator.css";


type PanelSelectIndicatorProps = {
    indicators?: IndicatorDTO[],
    onClickItem?: any,
    selectedIndicatorId?: number,
}

class PanelSelectIndicator extends React.Component<PanelSelectIndicatorProps, any> {

    onClickItem(e: any, aoItem: any) {
        if (_.isNil(this.props.onClickItem))
            return;

        this.props.onClickItem(aoItem);
    } // onClickItem

    render() {
        if (_.isEmpty(this.props.indicators))
            return null;

        return (
            <div className="panel-select-indicator-container">
                <ListGroup className="panel-select-indicator">
                    {
                        !_.isNil(this.props.indicators)
                        && _.map(
                            this.props.indicators,
                            (aoItem, aiIndex) => {
                                return (
                                    <ListGroupItem key={aiIndex} onClick={(e) => this.onClickItem(e, aoItem)}>
                                        <span className={`indicator-selection${(aoItem.indicatorID === this.props.selectedIndicatorId ? " selected" : "")}`}>
                                        </span>
                                        <span className="indicator-name">
                                            {aoItem.name}
                                        </span>
                                        <span className="indicator-type-name">
                                            {aoItem.typeName}
                                        </span>
                                    </ListGroupItem>
                                );
                            }
                        )
                    }
                </ListGroup>
            </div>
        );
    } // render
}


export default PanelSelectIndicator;